import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Translate, I18n } from 'react-redux-i18n';
import MiniLoader from 'components/MiniLoader';
import { Trash } from 'theme/icon';
import * as actions from 'redux/actions/optionAlertActions';
import { confirmDelete } from 'utils/confirmDialog';
import 'assets/css/alerts.css';

function formatMoney(value) {
    const n = Number(value);
    if (!Number.isFinite(n)) {
        return '—';
    }
    return n.toFixed(2);
}

function formatOptionLabel(item) {
    const parts = [
        String(item.symbol || '').toUpperCase(),
        item.strike != null ? String(item.strike) : null,
        item.option_kind || null,
        item.expire_at || null,
    ].filter(Boolean);
    return parts.join(' ');
}

const OptionAlertTable = (props) => {
    useEffect(() => {
        if (props.user_id) {
            props.loadList({ id: props.user_id }, props.token);
        }
    }, [props.user_id]);

    const onClickDelete = (item) => {
        confirmDelete(I18n.t('delete_confirm_message'), () => {
            props.removeItem({
                id: props.user_id,
                alert_id: item.id,
            }, props.token);
        });
    };

    return (
        <div className="alerts-table-wrapper">
            {props.loading && props.list.length === 0 ? (
                <div className="alerts-loading">
                    <MiniLoader />
                </div>
            ) : props.list.length === 0 ? (
                <p className="alerts-empty">
                    <Translate value="alerts_options_empty" />
                </p>
            ) : (
                <table className="table table-hover alerts-table">
                    <thead>
                        <tr>
                            <th align="left"><Translate value="option_alert_contract" /></th>
                            <th><Translate value="option_alert_profit" /></th>
                            <th className="text-end"><Translate value="option_alert_contract_value" /></th>
                            <th className="text-end"><Translate value="option_alert_profit_value" /></th>
                            <th className="text-end"><Translate value="alerts_target_price" /></th>
                            <th><Translate value="alerts_status" /></th>
                            <th className="text-center">A</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.list.map((item) => (
                            <tr key={item.id}>
                                <td>
                                    <div className="alerts-symbol-meta">
                                        <span className="alerts-symbol-link">
                                            {formatOptionLabel(item)}
                                        </span>
                                        {item.market && (
                                            <span className="alerts-symbol-name">{item.market}</span>
                                        )}
                                    </div>
                                </td>
                                <td className="alerts-operator">{item.percent}%</td>
                                <td className="text-end">${formatMoney(item.contract_value)}</td>
                                <td className="text-end">${formatMoney(item.profit_target)}</td>
                                <td className="text-end">${formatMoney(item.target_price)}</td>
                                <td>
                                    <span className={`alerts-status alerts-status--${(item.status || 'ACTIVE').toLowerCase()}`}>
                                        {item.status || 'ACTIVE'}
                                    </span>
                                </td>
                                <td className="text-center">
                                    <button
                                        type="button"
                                        className="watchlist-action-icon"
                                        onClick={() => onClickDelete(item)}
                                        aria-label="Delete alert"
                                    >
                                        <Trash />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

OptionAlertTable.propTypes = {
    list: PropTypes.array.isRequired,
};

function mapStateToProps(reducer) {
    return {
        user_id: reducer.session.auth.id,
        token: reducer.session.auth.token,
        list: reducer.optionAlert.list,
        loading: reducer.optionAlert.loading,
        error: reducer.optionAlert.error,
    };
}

const mapDispatchToProps = (dispatch) => ({
    loadList: (params, token) => dispatch(actions.loadList({ params, token })),
    removeItem: (params, token) => dispatch(actions.removeItem({ params, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(OptionAlertTable);
